var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvgsentimentreporticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2290"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 187",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DB4225"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ar_on_you"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_2056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar_on_you_2",
    d: "M19.2039 13C21.4379 13 23.3306 13.7264 24.8821 15.1793C26.4337 16.6321 27.2094 18.4051 27.2094 20.4985C27.2094 22.5918 26.4342 24.3653 24.8838 25.8192C23.3333 27.273 21.4411 28 19.2071 28C16.9732 28 15.0804 27.2735 13.5289 25.8207C11.9774 24.3679 11.2016 22.5948 11.2016 20.5015C11.2016 18.4082 11.9768 16.6346 13.5273 15.1808C15.0777 13.7269 16.9699 13 19.2039 13ZM19.2055 26.5C20.9842 26.5 22.496 25.9166 23.7411 24.75C24.9861 23.5833 25.6087 22.1666 25.6087 20.5C25.6087 18.8333 24.9861 17.4166 23.7411 16.25C22.496 15.0833 20.9842 14.5 19.2055 14.5C17.4269 14.5 15.915 15.0833 14.6699 16.25C13.4249 17.4166 12.8023 18.8333 12.8023 20.5C12.8023 22.1666 13.4249 23.5833 14.6699 24.75C15.915 25.9166 17.4269 26.5 19.2055 26.5ZM19.2055 23.8077C20.0114 23.8077 20.7386 23.5977 21.3871 23.1779C22.0356 22.758 22.5056 22.1987 22.797 21.5H15.614C15.9054 22.1987 16.3754 22.758 17.0239 23.1779C17.6725 23.5977 18.3997 23.8077 19.2055 23.8077ZM15.614 18.5017C15.614 18.7582 15.7066 18.9727 15.8918 19.1452C16.0771 19.3176 16.3066 19.4038 16.5804 19.4038C16.8542 19.4038 17.0831 19.317 17.2671 19.1435C17.4511 18.9699 17.5431 18.7548 17.5431 18.4983C17.5431 18.2417 17.4505 18.0272 17.2653 17.8548C17.0801 17.6824 16.8506 17.5961 16.5768 17.5961C16.303 17.5961 16.074 17.6829 15.89 17.8565C15.706 18.03 15.614 18.2451 15.614 18.5017ZM20.8679 18.5017C20.8679 18.7582 20.9605 18.9727 21.1457 19.1452C21.3309 19.3176 21.5604 19.4038 21.8342 19.4038C22.1081 19.4038 22.337 19.317 22.521 19.1435C22.705 18.9699 22.797 18.7548 22.797 18.4983C22.797 18.2417 22.7044 18.0272 22.5192 17.8548C22.334 17.6824 22.1045 17.5961 21.8306 17.5961C21.5568 17.5961 21.3279 17.6829 21.1439 17.8565C20.9599 18.03 20.8679 18.2451 20.8679 18.5017ZM8.00003 14.5V12.6953C8.00003 11.9433 8.27936 11.3061 8.83804 10.7837C9.3967 10.2612 10.0751 10 10.8732 10H12.8023V11.5H10.8732C10.5127 11.5 10.2105 11.6142 9.9666 11.8428C9.72271 12.0713 9.60076 12.3545 9.60076 12.6923V14.5H8.00003ZM10.8763 31C10.0738 31 9.39382 30.7382 8.83628 30.2147C8.27876 29.6912 8 29.0555 8 28.3077V26.5H9.60076V28.3077C9.60076 28.6455 9.72271 28.9287 9.9666 29.1572C10.2105 29.3857 10.5127 29.5 10.8732 29.5H12.8023V30.9999L10.8763 31ZM25.6087 30.9038V29.4038H27.5378C27.8983 29.4038 28.2005 29.2896 28.4444 29.061C28.6883 28.8325 28.8103 28.5493 28.8103 28.2115V26.4038H30.411V28.2085C30.411 28.9605 30.1317 29.5977 29.573 30.1201C29.0143 30.6426 28.3359 30.9038 27.5378 30.9038H25.6087ZM28.8103 14.5V12.6923C28.8103 12.3545 28.6883 12.0713 28.4444 11.8428C28.2005 11.6142 27.8983 11.5 27.5378 11.5H25.6087V10H27.5347C28.3372 10 29.0172 10.2618 29.5747 10.7853C30.1322 11.3088 30.411 11.9444 30.411 12.6923V14.5H28.8103Z",
    fill: "#1C1B1F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgsentimentreporticon);
export default __webpack_public_path__ + "static/media/avgsentimentreporticon.ba86092cabaee7e779fdcb3e8bf59d9a.svg";
export { ForwardRef as ReactComponent };